import ShareKakaoLink from './ShareKakaoLink';
import ShareKakaoStory from './ShareKakaoStory';
import ShareKakaoStorySimpleUrlLink from './ShareKakaoStorySimpleUrlLink';
import ShareCatMessenger from './ShareCatMessenger';

class ShareEvent{
  constructor( options ){
    this.options = options;
    let _opts = this.options;
    this.kakaoLink = '';
    _opts.url = encodeURIComponent( _opts.url );
  }

  resetFacebook( $node, options ){
    this.options = options;
    this.addFacebook( $node );
  }

  resetTwitter( $node, options ){
    this.options = options;
    this.addTwitter( $node );
  }

  resetLine( $node, options ){
    this.options = options;
    this.addLine( $node );
  }

  resetGooglePlus( $node, options ){
    this.options = options;
    this.addGooglePlus( $node );
  }

  resetCatMessager( $node, options ) {
    this.options = options;
    this.addCatMessager( $node );
  }

  resetKakaoLink( $node, options ){
    this.options = options;
    this.addKakaoLink( $node );
  }

  resetKakaoStory( $node, options ){
    this.options = options;
    this.addKakaoStory( $node );
  }

  addClickTrace( $node, kind = '' ){
    let logger = this.options.clickTracePrefix + kind;
    $node.attr( 'onmousedown', 'try{_trk_clickTrace(\"EVT\", \"/'+logger+'\");}catch(_e){}');
  }

  addFacebook( $node ){

    if ( !$node.length ) {
      return;
    }

    let _opts = this.options;
    $node.attr( 'href', 'href="javascript:void(0)"' )
      .attr( 'onclick', 'window.open("http://www.facebook.com/share.php?u=' + _opts.url + '", "share" );return false');
      //.attr( 'target', '_blank' );
    this.addClickTrace( $node, 'facebook' );
  }

  addTwitter( $node ){

    if ( !$node.length ) {
      return;
    }

    let _opts = this.options;
    let url = _opts.url; //encodeURIComponent( _opts.url );
    let msg = encodeURIComponent( _opts.msg );

    $node.attr( 'href', 'http://twitter.com/share?url=' + url + '&text=' + msg )
      .attr( 'target', '_blank' );
    this.addClickTrace( $node, 'twitter' );
  }

  addKakaoLink( $node ){

    if ( !$node.length ) {
      return;
    }

    let _opts = this.options;
    if( !this.kakaoLink ){
      this.kakaoLink = new ShareKakaoLink( $node, _opts);
    }else{
      this.kakaoLink.resetKakaoLink( _opts );
    }

  }

  addKakaoStory( $node ){

    if ( !$node.length ) {
      return;
    }

    let _opts = this.options, This = this;
    $node.off( 'click' ).on( 'click', function( evt ){
      nc.uikit.ShareKakaoStorySimpleUrlLink( _opts.url );
      This.addClickTrace( $node, 'kakaostory' );
    });
  }

  addCatMessager( $node ){

    if ( !$node.length ) {
      return;
    }

    let _opts = this.options, This = this;
    let shareCatMessenger = new ShareCatMessenger();
    $node.off( 'click' ).on( 'click', function( evt ){
      shareCatMessenger.execute( _opts.msg, _opts.url, '' );
      This.addClickTrace( $node, 'cat' );
    });
  }

  addLine( $node ){

    if ( !$node.length ) {
      return;
    }

    let _opts = this.options, This = this;
    $node.on( 'click', function( evt ){
      $node.attr( 'href', 'http://line.me/R/msg/text/?' + _opts.msg + ' - ' + _opts.url )
        .attr( 'target', '_blank' );
      This.addClickTrace( $node, 'line' );
    });
  }

  addGooglePlus( $node ){

    if ( !$node.length ) {
      return;
    }

    let _opts = this.options;
    //$node.attr( 'href', 'https://plus.google.com/share?url=' + _opts.url + '&text=' + _opts.msg )
    $node.attr( 'href', 'https://plus.google.com/share?url=' + _opts.url )
      .attr( 'target', '_blank' );
    this.addClickTrace( $node, 'google_plus' );

    //<a href=https://plus.google.com/share?url={URL}" onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;"><img src="https://www.gstatic.com/images/icons/gplus-64.png" alt="Share on Google+"/></a>
  }
}

export default ShareEvent;
